import clsx from "clsx";

const barBase = "shrink-0 rounded-sm";

export type AccentBarSize = "legend" | "row";

const sizeClasses: Record<AccentBarSize, string> = {
  /** Same proportions as meetings subtitle legend (`meetings.tsx` accentBar). */
  legend: "h-4 w-1",
  /** Taller bar for mission list cards (reads as a rail, not a dot). */
  row: "w-1 self-stretch min-h-[2.75rem]",
};

export interface AccentBarProps {
  /** Tailwind background utility, e.g. `bg-amber-400`. */
  bgClassName: string;
  /** `legend` matches meetings pills; `row` stretches with the card row. */
  size?: AccentBarSize;
  className?: string;
}

/**
 * Vertical color rail used in Meetings legend pills and Mission Control
 * status/mission chrome — keeps list and filter visuals aligned.
 */
export function AccentBar({
  bgClassName,
  size = "legend",
  className,
}: AccentBarProps) {
  return (
    <span
      aria-hidden
      className={clsx(barBase, sizeClasses[size], bgClassName, className)}
    />
  );
}
